import get from 'lodash/get.js';

import axios from '@/plugins/axios.js';

/** Return a positive, safely representable decimal ID without accepting numeric prefixes. */
export function parseGradebookId(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value))) {
        return null;
    }

    const parsed = Number(value);

    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
}

export function resolveGradebookIdSync({ gradebookId, course = null }) {
    return parseGradebookId(gradebookId) ?? parseGradebookId(get(course, 'gradebook.id'));
}

export async function resolveGradebookId({ courseId, gradebookId, getCourse = null, fetchCourse = null }) {
    const explicitId = parseGradebookId(gradebookId);
    if (explicitId !== null) {
        return explicitId;
    }

    const cachedId = parseGradebookId(get(getCourse?.(courseId), 'gradebook.id'));
    if (cachedId !== null) {
        return cachedId;
    }

    const loadCourse =
        fetchCourse ??
        (async id => {
            const { data } = await axios.get(`/api/courses/${id}`, { errorHandle: false });

            return data.data;
        });

    const course = await loadCourse(courseId);
    const resolvedId = parseGradebookId(get(course, 'gradebook.id'));

    if (resolvedId === null) {
        throw new Error(`No gradebook found for course ${courseId}`);
    }

    return resolvedId;
}
